(function ($) {

  function countChar(val) {
    let len = val.value.length;
    let max = val.attributes.maxLength.value
    if (len > max) {
      val.value = val.value.substring(0, max);
    } else {
      $('#numbers').text(len + '/' + max);
    }
  }

  function setLocalStorage(name, value) {
    localStorage.setItem(name, value);
  }

  function removeLocalStorage(name) {
    localStorage.removeItem(name);
  }

  function extractHostname(url) {
    var hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname

    if (url.indexOf("://") > -1) {
      hostname = url.split('/')[2];
    }
    else {
      hostname = url.split('/')[0];
    }

    //find & remove port number
    hostname = hostname.split(':')[0];
    //find & remove "?"
    hostname = hostname.split('?')[0];

    return hostname;
  }

  // To address those who want the "root domain," use this function:
  function getDomainName(url) {
    var domain = extractHostname(url),
      splitArr = domain.split('.'),
      arrLen = splitArr.length;

    //extracting the root domain here
    //if there is a subdomain
    if (arrLen > 2) {
      domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
      //check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
      if (splitArr[arrLen - 2].length == 2 && splitArr[arrLen - 1].length == 2) {
        //this is using a ccTLD
        domain = splitArr[arrLen - 3] + '.' + domain;
      }
    }
    return domain;
  }

  $(document).ready(function() {

    $('#settingsCookies').on('click', function(event) {
      $('#cookies').toggleClass('mobile-cookies');
      $(this).closest('.cookies-container').find('.cookies-settings').toggleClass('d-flex');
    });

    $('#declineCookies').on('click', function(event) {
      var domainName = getDomainName(document.location.hostname);
      var privacy = {};
      privacy['analytics'] = 0;
      $.cookie("privacy", JSON.stringify(privacy), {  expires: 365, path: '/', domain: '.' + domainName, secure: true } );
      location.reload();
    });

    $('#acceptCookies').on('click', function(event) {
      var domainName = getDomainName(document.location.hostname);
      var privacy = {};

      if($("#cookieAnalyticsHeaderBanner").is(':checked')) {
        privacy['analytics'] = 1;
      }else{
        privacy['analytics'] = 0;
      }

      $.cookie("privacy", JSON.stringify(privacy), {  expires: 365, path: '/', domain: '.' + domainName, secure: true });
      location.reload();
    });

    let windowsWidth = $(window).outerWidth();

    //Added JS code from main website
    if (windowsWidth <= 992) {

      $('.navbar-collapse').on('click', function() {
        $('.lv-navbar .navbar-toggler').click();
      });

      $('.navbar-nav').on('click', function(event) {
        event.stopPropagation();
      });
    }

    $('.nav-close').on('click', function() {
      $('.lv-navbar .navbar-toggler').click();
    });

    let dropdownEl = $('#tabMenu');

    if (dropdownEl.length) {
      let btn = $('#tabMenu ~ .dropdown-menu .dropdown-item');

      btn.on('click', function() {
        $($(this).data('bs-target')).click();
        dropdownEl.text($(this).text());
        btn.removeClass('active');
        $(this).addClass('active');
      });
    }
    //============================================================

    let adminBar = $('#wpadminbar');

    if (adminBar.length) {
      let mainNav = $('.lv-navbar');
      let specialOffer = $('.special-offer');

      if (specialOffer.length) {
        specialOffer.css('margin-top', adminBar.outerHeight());

        $(window).on('resize', function(){
          specialOffer.css('margin-top', adminBar.outerHeight());
        });
      }

      mainNav.css('margin-top', adminBar.outerHeight());

      $(window).on('resize', function(){
        mainNav.css('margin-top', adminBar.outerHeight());
      });

      if (windowsWidth <= 992) {
        $('.lv-mobile-filter-options').css('height', 'calc(100vh - ' + adminBar.outerHeight() + ')').css('margin-top', adminBar.outerHeight());
      }
    }

    if (windowsWidth <= 992) {

      $('.lv-mobile-filter-options-outline').on('click', function() {
        $('.js-mobile-filter-toggle').click();
      });

      $('.lv-mobile-filter-options').on('click', function(event) {
        event.stopPropagation();
      });
    }

    $('.js-filter-close').on('click', function() {
      $('.js-mobile-filter-toggle').click();
    });

    $('.js-mobile-filter-toggle').on('click', function() {
      $('.filter-container').toggleClass('f-open');
    });

    let backBtn = $('.js-btn-back');

    if (backBtn.length) {
      if (history.length > 1) {
        backBtn.on('click', function(e) {
          e.preventDefault();
          history.back();
        });
      }
    }

    let copyPostUrl = $('.js-btn-copy-post-url');
    if (copyPostUrl.length) {
      copyPostUrl.on('click', function (e) {
        e.preventDefault();
        let copyText = $(this).attr('href');

        document.addEventListener('copy', function (e) {
          e.clipboardData.setData('text/plain', copyText);
          e.preventDefault();
        }, true);

        copyPostUrl.find('.js-copy-msg').addClass('show');

        setTimeout(function(){
          copyPostUrl.find('.js-copy-msg').removeClass('show');
        }, 3500);

        document.execCommand('copy');
      });
    }

    $('._js-btnBuyNow').on('click', function(){
      setLocalStorage('smoothScroll',1);
    });

    $('._js-btnBuyNowModal').on('click', function(e){
      setLocalStorage('btnBuyNowModal',1);
    });

    let btnLearnMore = $('button.js-btn-learn-more');
    if (btnLearnMore.length) {
      $('button.js-btn-learn-more').removeClass('lv-hide');

      $('.js-btn-learn-more').on('click', function() {
        let href = $(this).data('href');

        if (href.length) {
          let target = $(this).data('target');

          if (target === '_blank') {
            window.open(href, '_blank');
          } else {
            window.location.href = href;
          }
        }
      });
    }

    // Section template resources
    let lvHelpCentreCarousel = $('.js-lv-help-centre-carousel');

    if (lvHelpCentreCarousel.length) {
      lvHelpCentreCarousel.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        centerMode: false,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              centerMode: false,
              variableWidth: true
            },
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true,
              centerMode: false,
              variableWidth: true
            }
          }
        ]
      });
    }
    //============================================================
  });
})(jQuery);
